import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import i18n from './i18n';
import 'vant/lib/index.css';
// 解析 URL 參數
function getLanguageFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('lang') || 'en'; // 如果沒有 lang 參數，則使用預設語言 'en'
}

// 設置語言
i18n.global.locale.value = getLanguageFromURL();

const app = createApp(App);
app.use(i18n);
app.use(router);
app.use(Vant);
app.mount('#app')
